
import { createAction, props } from '@ngrx/store';

export const memberFormConfigData = createAction('[Data memberFormConfigData API] Load Data');
export const memberFormConfigDataSuccess = createAction('[Data memberFormConfigData API] Load Data Success', props<any>());
export const memberFormConfigDataFailure = createAction('[Data memberFormConfigData API] Load Data Failure', props<any>());
